<main class="fixture-shell">
  <section class="fixture-header">
    <div>
      <p class="fixture-kicker">Local widget smoke harness</p>
      <h1>Product Card Preview</h1>
      <p>
        Seeds one synthetic reserved conversation for <strong>{{ chatbotId }}</strong> under the current local client
        scope, then opens the real widget modal with forced conversation replay.
      </p>
    </div>
    <div class="fixture-route">
      <span>Route</span>
      <strong>/ai/chatbots/widget-preview/product-card</strong>
      <code>localhost only</code>
    </div>
  </section>

  <section class="fixture-meta">
    <span><strong>Client</strong> {{ clientId || 'Missing' }}</span>
    <span><strong>Chatbot</strong> {{ chatbotId || 'Missing' }}</span>
    <span><strong>Fixture</strong> product-card</span>
  </section>

  <section class="fixture-toolbar">
    <button mat-flat-button color="primary" (click)="seedAndOpen()" [disabled]="loading || !clientId || !chatbotId">
      Reseed and open
    </button>
    <button mat-stroked-button (click)="openPreview()" [disabled]="loading || !fixtureState?.seeded">
      Open current preview
    </button>
    <button mat-stroked-button (click)="refresh()" [disabled]="loading || !clientId || !chatbotId">
      Refresh state
    </button>
    <button mat-stroked-button color="warn" (click)="reset()" [disabled]="loading || !clientId || !chatbotId">
      Reset fixture
    </button>
  </section>

  @if (errorMessage) {
    <section class="fixture-alert">
      <h2>Preview unavailable</h2>
      <p>{{ errorMessage }}</p>
    </section>
  }

  <section class="fixture-surface">
    <div class="fixture-state">
      <div>
        <span>Status</span>
        <strong>{{ fixtureState?.seeded ? 'Seeded' : 'Not seeded' }}</strong>
      </div>
      <div>
        <span>Conversation</span>
        <code>{{ fixtureState?.conversationId || 'Unavailable' }}</code>
      </div>
      <div>
        <span>Messages</span>
        <strong>{{ fixtureState?.messageCount ?? 0 }}</strong>
      </div>
    </div>

    <div class="fixture-notes">
      <p>Preview launch reuses the existing widget preview flow: forced conversation id, cookie override, event dispatch, and modal open.</p>
      <p>The fixture payload stays synthetic and does not read or replay arbitrary conversations.</p>
    </div>
  </section>
</main>
